var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      !_vm.isSystemSalesRoleOnly
        ? _c(
            "v-layout",
            { attrs: { "justify-start": "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    disabled: _vm.featuresManagementButtonDisabled
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.showFeatureEditDialog.apply(null, arguments)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("editFeatures")))]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    disabled: !_vm.canManageSystemOfflineDeposit
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.showOfflineDepositDialog.apply(null, arguments)
                    }
                  }
                },
                [
                  _vm._v(_vm._s(_vm.$t("offlineDeposit")) + "\n      "),
                  _c("v-badge", {
                    staticClass: "openBadge",
                    attrs: {
                      value: _vm.checkNewOffline,
                      color: "red",
                      overlap: ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "badge",
                          fn: function() {
                            return [
                              _c("span", { staticClass: "badge" }, [
                                _vm._v(_vm._s(_vm.$t("new")))
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      2253888256
                    )
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.showApplicationDialog.apply(null, arguments)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("featureApplication")))]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.showDayEndClosingDialog.apply(null, arguments)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("dayEndClosing")))]
              ),
              _vm._v(" "),
              _c(
                "v-menu",
                {
                  attrs: { "offset-y": "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-btn",
                              _vm._g({ attrs: { color: "primary" } }, on),
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.$t("export")) +
                                    "\n          "
                                ),
                                _c("v-icon", { attrs: { size: "20" } }, [
                                  _vm._v("expand_more")
                                ])
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3093046187
                  )
                },
                [
                  _vm._v(" "),
                  !_vm.isSystemSalesRoleOnly
                    ? [
                        _c(
                          "v-list",
                          {
                            staticClass: "primary menu-list-btn",
                            attrs: { dark: "" },
                            nativeOn: {
                              click: function($event) {
                                $event.stopPropagation()
                                return function() {
                                  return _vm.exportTableData()
                                }.apply(null, arguments)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("exportClientExpense")) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    {
                      staticClass: "primary menu-list-btn",
                      attrs: { dark: "" },
                      nativeOn: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.showExportClientsRechargeTransactionDialog.apply(
                            null,
                            arguments
                          )
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("exportClientsRechargeTransaction")) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.isSystemSalesRoleOnly
                    ? [
                        _c(
                          "v-list",
                          {
                            staticClass: "primary menu-list-btn",
                            attrs: { dark: "" },
                            nativeOn: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.exportTableDataDetail.apply(
                                  null,
                                  arguments
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("exportClientExpenseDetail")) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { "justify-space-between": "", "align-baseline": "" } },
        [
          _c(
            "v-flex",
            { staticClass: "success--text caption", attrs: { md5: "" } },
            [
              _c(
                "v-layout",
                {
                  attrs: {
                    row: "",
                    "align-end": "",
                    "justify-space-between": ""
                  }
                },
                [
                  _c("v-flex", [
                    _c("span", { staticClass: "realtime-border px-1" }, [
                      _vm._v(_vm._s(_vm.$t("realTIME")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          "hide-details": "",
                          label: _vm.$t("clientType"),
                          items: _vm.clientTypeList,
                          "item-value": "type",
                          "item-text": "text",
                          clearable: ""
                        },
                        model: {
                          value: _vm.filterClientType,
                          callback: function($$v) {
                            _vm.filterClientType = $$v
                          },
                          expression: "filterClientType"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "modes" },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          "hide-details": "",
                          label: _vm.$t("mode"),
                          items: _vm.modeList,
                          "item-value": "type",
                          "item-text": "text",
                          clearable: ""
                        },
                        model: {
                          value: _vm.modeType,
                          callback: function($$v) {
                            _vm.modeType = $$v
                          },
                          expression: "modeType"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasAuthToFunctionality("sysfinancialReport")
            ? [
                _c(
                  "v-flex",
                  { attrs: { md2: "" } },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "primary", flat: "", icon: "" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.showExpenseHistoryDialog(
                              _vm.totalExpenseHistory
                            )
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { color: "info" } }, [
                          _vm._v("info")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { md2: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("filter"),
                  "hide-details": "",
                  clearable: ""
                },
                model: {
                  value: _vm.filter,
                  callback: function($$v) {
                    _vm.filter = $$v
                  },
                  expression: "filter"
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.balanceHeaders,
          items: _vm.balances,
          search: _vm.filter,
          "rows-per-page-items": _vm.rowPerPage,
          pagination: _vm.pagination
        },
        on: {
          "update:pagination": function($event) {
            _vm.pagination = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "td",
                  { staticClass: "subheading" },
                  [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(tooltip) {
                                return [
                                  _c(
                                    "div",
                                    _vm._g({}, tooltip.on),
                                    [
                                      _c("v-layout", [
                                        _c(
                                          "strong",
                                          [
                                            item.type === "warehouse"
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "20px"
                                                    }
                                                  },
                                                  [_vm._v("local_shipping")]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.type === "organization"
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "20px"
                                                    }
                                                  },
                                                  [_vm._v("business")]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.isBlockCreditCardDeposit
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "20px"
                                                    }
                                                  },
                                                  [_vm._v("strikethrough_s")]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            ref: item.clientKey + "-name",
                                            staticClass: "text-overflow-hide",
                                            staticStyle: {
                                              color: "black",
                                              "font-weight": "bolder",
                                              cursor: "pointer"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.toggleOverflowStyle(
                                                  item.clientKey + "-name"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(item.clientName) +
                                                _vm._s(
                                                  item.companyName
                                                    ? "(" +
                                                        item.companyName +
                                                        ")"
                                                    : ""
                                                )
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      item.orgKey ||
                                      item.apiKey ||
                                      item.mode === "label"
                                        ? _c("v-layout", [
                                            _vm._v(
                                              _vm._s(_vm.$t("mode")) +
                                                ": " +
                                                _vm._s(_vm.$t("label"))
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("v-layout", [
                                        _vm._v("(" + _vm._s(item.email) + ")")
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("registTime") +
                                ": " +
                                _vm.toTimestampString(item.createTime)
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-center" }, [
                  item.contractSigning
                    ? _c("div", { staticStyle: { "font-size": "12px" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              item.contractSignStartDate &&
                                item.contractSignStartDate
                                  .toISOString()
                                  .slice(0, 10)
                            ) +
                            "\n          "
                        ),
                        _c("br"),
                        _vm._v(" ~ "),
                        _c("br"),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              item.contractSignEndDate &&
                                item.contractSignEndDate
                                  .toISOString()
                                  .slice(0, 10)
                            ) +
                            "\n        "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-center" },
                  [
                    item.status
                      ? _c("v-icon", [_vm._v("check_circle")])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-center" },
                  [
                    _vm.isImportServiceAvailable && item.isOverseaCustomer
                      ? _c("v-icon", [_vm._v("check_circle")])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _c(
                      "v-layout",
                      { attrs: { "justify-start": "", "align-center": "" } },
                      [
                        _c(
                          "v-flex",
                          _vm._l(item.tags, function(tag) {
                            return _c("v-chip", { key: tag }, [
                              _vm._v(_vm._s(tag))
                            ])
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { md2: "" } },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: { small: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.showEditTagsPopup(item)
                                  }
                                }
                              },
                              [_vm._v("edit")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _c(
                      "v-layout",
                      { attrs: { "justify-start": "", "align-center": "" } },
                      [
                        _c("v-flex", [
                          _vm._v(
                            "\n            $" +
                              _vm._s(
                                item.balance && item.balance.toLocaleString()
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        item.orgKey || item.apiKey || item.mode === "label"
                          ? _c(
                              "v-flex",
                              {
                                staticClass: "align-right",
                                attrs: { md2: "" }
                              },
                              [
                                _c("LoaderButton", {
                                  staticClass: "refreshBalance",
                                  attrs: {
                                    flat: "",
                                    isSmall: "",
                                    promiseAwait: _vm.refreshBalance,
                                    promiseItem: item
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "icon",
                                        fn: function() {
                                          return [
                                            _c("v-icon", [_vm._v("refresh")])
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isShowMargin
                  ? _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(_vm._s(item.margin || 0) + "%")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isShowMonthlyFee
                  ? _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v("$" + _vm._s(item.monthlyFee || 0))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(
                    "$" +
                      _vm._s(item.lowestBalance || 0) +
                      "/$" +
                      _vm._s(item.bond || 0) +
                      " "
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(
                    _vm._s(
                      (item.department || "N/A") +
                        " / " +
                        (item.accountManager || "N/A")
                    )
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _c(
                    "div",
                    {
                      ref: item.clientKey + "-note",
                      staticClass: "text-overflow-hide",
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function($event) {
                          return _vm.toggleOverflowStyle(
                            item.clientKey + "-note"
                          )
                        }
                      }
                    },
                    [_vm._v(_vm._s(item.note))]
                  )
                ]),
                _vm._v(" "),
                !_vm.roles.includes("sysAdminOverseaOperator")
                  ? _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(
                        "$" +
                          _vm._s(
                            _vm
                              .getExpense(item.expenseHistory, 0)
                              .toLocaleString()
                          )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.roles.includes("sysAdminOverseaOperator")
                  ? _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(
                        "$" +
                          _vm._s(
                            _vm
                              .getExpense(item.expenseHistory, 1)
                              .toLocaleString()
                          )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.roles.includes("sysAdminOverseaOperator")
                  ? _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(
                        "$" +
                          _vm._s(
                            _vm
                              .getExpense(item.expenseHistory, 2)
                              .toLocaleString()
                          )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _c(
                      "v-layout",
                      { attrs: { "justify-center": "" } },
                      [
                        !_vm.isSystemSalesRoleOnly
                          ? _c(
                              "v-tooltip",
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(tooltip) {
                                        return [
                                          _c(
                                            "div",
                                            _vm._g({}, tooltip.on),
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    icon: "",
                                                    color: "primary",
                                                    flat: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.showConfigDialog(
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [_vm._v("edit")])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("edit")) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "v-menu",
                          {
                            attrs: { "offset-y": "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { top: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(tooltip) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      _vm._g({}, tooltip.on),
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              icon: "",
                                                              color: "primary",
                                                              flat: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return on.click.apply(
                                                                  null,
                                                                  arguments
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v("build")
                                                            ])
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.$t("more")) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "v-list",
                              [
                                !_vm.isSystemSalesRoleOnly &&
                                !(item.orgKey || item.mode === "label")
                                  ? _c(
                                      "v-list-tile",
                                      {
                                        attrs: {
                                          disabled: !_vm.canAdjustSystemBalance
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.showAdjustDialog(item)
                                          }
                                        }
                                      },
                                      [
                                        _c("v-list-tile-title", [
                                          _vm._v(_vm._s(_vm.$t("adjust")))
                                        ])
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-list-tile",
                                  {
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.showExpenseHistoryDialog(
                                          item.expenseHistory
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("v-list-tile-title", [
                                      _vm._v(_vm._s(_vm.$t("history")))
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-tile",
                                  {
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.showDetailDialog(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("v-list-tile-title", [
                                      _vm._v(_vm._s(_vm.$t("detail")))
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-tile",
                                  {
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.showLabelInvoicesDialog(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("v-list-tile-title", [
                                      _vm._v(_vm._s(_vm.$t("invoice")))
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _vm.adjustBalanceDialog
        ? _c("AdjustBalancePopup", {
            attrs: {
              adjustment: _vm.adjustBalance,
              actionFunc: _vm.addAdjustBalance
            },
            model: {
              value: _vm.adjustBalanceDialog,
              callback: function($$v) {
                _vm.adjustBalanceDialog = $$v
              },
              expression: "adjustBalanceDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.expenseHistoryDialog
        ? _c("ExpenseHistoryPopup", {
            attrs: { expenseHistory: _vm.expenseHistory },
            model: {
              value: _vm.expenseHistoryDialog,
              callback: function($$v) {
                _vm.expenseHistoryDialog = $$v
              },
              expression: "expenseHistoryDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.featureDialog
        ? _c("FormSubmitPopup", {
            attrs: {
              title: _vm.$t("featuresManagement"),
              medium: "",
              rightMethod: _vm.editFeature,
              rightButtonDisabled: _vm.featuresManagementButtonDisabled,
              rightButtonText: _vm.$t("submit")
            },
            on: {
              popupClose: function($event) {
                _vm.featureDialog = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-container",
                                { attrs: { fluid: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { md3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: { label: _vm.$t("apiId") },
                                            model: {
                                              value: _vm.eeveeOrgIdDisplay,
                                              callback: function($$v) {
                                                _vm.eeveeOrgIdDisplay = $$v
                                              },
                                              expression: "eeveeOrgIdDisplay"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-container",
                                    { staticClass: "grey lighten-5 mb-6" },
                                    [
                                      _vm._l(
                                        _vm.fullBetaFeatures.filter(function(
                                          item
                                        ) {
                                          return item.type !== "payment"
                                        }),
                                        function(item, index) {
                                          return _c(
                                            "v-layout",
                                            {
                                              key: item.displayName + index,
                                              attrs: { row: "" }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { md5: "" } },
                                                [
                                                  _c("v-checkbox", {
                                                    attrs: {
                                                      value: item.key,
                                                      label: item.displayName
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.changeFeature(
                                                          item
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: _vm.features,
                                                      callback: function($$v) {
                                                        _vm.features = $$v
                                                      },
                                                      expression: "features"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { md3: "" } },
                                                [
                                                  _c("v-switch", {
                                                    attrs: {
                                                      disabled: !_vm.features.includes(
                                                        item.key
                                                      ),
                                                      label: _vm.$t(
                                                        item.isVisible
                                                          ? "visible"
                                                          : "inVisible"
                                                      )
                                                    },
                                                    model: {
                                                      value: item.isVisible,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "isVisible",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.isVisible"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c("h3", [_vm._v(_vm._s(_vm.$t("pay")))]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.fullBetaFeatures.filter(function(
                                          item
                                        ) {
                                          return item.type === "payment"
                                        }),
                                        function(item, index) {
                                          return _c(
                                            "v-layout",
                                            {
                                              key: item.displayName + index,
                                              attrs: { row: "" }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { md5: "" } },
                                                [
                                                  _c("v-checkbox", {
                                                    attrs: {
                                                      value: item.key,
                                                      label: item.displayName
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.changeFeature(
                                                          item
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: _vm.features,
                                                      callback: function($$v) {
                                                        _vm.features = $$v
                                                      },
                                                      expression: "features"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { md3: "" } },
                                                [
                                                  _c("v-switch", {
                                                    attrs: {
                                                      disabled: !_vm.features.includes(
                                                        item.key
                                                      ),
                                                      label: _vm.$t(
                                                        item.isVisible
                                                          ? "visible"
                                                          : "inVisible"
                                                      )
                                                    },
                                                    model: {
                                                      value: item.isVisible,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "isVisible",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.isVisible"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1516123467
            ),
            model: {
              value: _vm.featureDialog,
              callback: function($$v) {
                _vm.featureDialog = $$v
              },
              expression: "featureDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.configDialog
        ? _c("FormSubmitPopup", {
            attrs: {
              title: _vm.$t("clientConfig"),
              medium: "",
              rightMethod: _vm.editConfig,
              rightButtonText: _vm.$t("submit")
            },
            on: {
              popupClose: function($event) {
                _vm.configDialog = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-container",
                        [
                          !_vm.clientInEdit.isModeLabel
                            ? _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.$t("minBalance"),
                                          prefix: "$",
                                          rules: [_vm.fieldIsNumber()]
                                        },
                                        model: {
                                          value: _vm.clientInEdit.lowestBalance,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.clientInEdit,
                                              "lowestBalance",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression:
                                            "clientInEdit.lowestBalance"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.$t("bond"),
                                          prefix: "$",
                                          rules: [_vm.fieldIsNumber()]
                                        },
                                        model: {
                                          value: _vm.clientInEdit.bond,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.clientInEdit,
                                              "bond",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "clientInEdit.bond"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.clientInEdit.isModeLabel
                            ? _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { md6: "" } },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: { "justify-space-between": "" }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md6: "" } },
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  label: _vm.$t("department"),
                                                  items: _vm.departments,
                                                  "item-text": "name",
                                                  "item-value": "name",
                                                  clearable: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.clientInEdit.department,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.clientInEdit,
                                                      "department",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "clientInEdit.department"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { md5: "" } },
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "accountManager"
                                                  ),
                                                  items: _vm.accountManagers,
                                                  clearable: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.clientInEdit
                                                      .accountManager,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.clientInEdit,
                                                      "accountManager",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "clientInEdit.accountManager"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { md6: "" } },
                                    [
                                      _c(
                                        "v-layout",
                                        [
                                          _vm.isShowMonthlyFee
                                            ? _c(
                                                "v-flex",
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "monthlyFee"
                                                      ),
                                                      prefix: "$",
                                                      rules: [
                                                        _vm.fieldIsNumber()
                                                      ]
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.clientInEdit
                                                          .monthlyFee,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.clientInEdit,
                                                          "monthlyFee",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "clientInEdit.monthlyFee"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.isShowMonthlyFee &&
                                          _vm.isShowMargin
                                            ? _c("v-spacer")
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.isShowMargin
                                            ? _c(
                                                "v-flex",
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      label: _vm.$t("margin"),
                                                      suffix: "%",
                                                      rules: [
                                                        _vm.fieldIsNumber()
                                                      ]
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.clientInEdit.margin,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.clientInEdit,
                                                          "margin",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "clientInEdit.margin"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { md3: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: { label: _vm.$t("companyName") },
                                    model: {
                                      value: _vm.clientInEdit.companyName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.clientInEdit,
                                          "companyName",
                                          $$v
                                        )
                                      },
                                      expression: "clientInEdit.companyName"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md2: "" } },
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      label: _vm.$t("blockCreditCardDeposit")
                                    },
                                    model: {
                                      value:
                                        _vm.clientInEdit
                                          .isBlockCreditCardDeposit,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.clientInEdit,
                                          "isBlockCreditCardDeposit",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "clientInEdit.isBlockCreditCardDeposit"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md2: "" } },
                                [
                                  _c("v-checkbox", {
                                    attrs: { label: _vm.$t("contractSigning") },
                                    model: {
                                      value: _vm.clientInEdit.contractSigning,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.clientInEdit,
                                          "contractSigning",
                                          $$v
                                        )
                                      },
                                      expression: "clientInEdit.contractSigning"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.clientInEdit.contractSigning
                                ? _c(
                                    "v-flex",
                                    { attrs: { md3: "" } },
                                    [
                                      _c("DatePicker", {
                                        attrs: {
                                          label: _vm.$t(
                                            "contractSigningValidDate"
                                          ),
                                          range: "",
                                          rules: [
                                            function(v) {
                                              return (
                                                (!v[0] || !v[1]) &&
                                                _vm.$t("required")
                                              )
                                            }
                                          ]
                                        },
                                        model: {
                                          value:
                                            _vm.clientInEdit
                                              .contractSigningValidDate,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.clientInEdit,
                                              "contractSigningValidDate",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "clientInEdit.contractSigningValidDate"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.clientInEdit.type === "organization"
                            ? _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { md3: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: { label: _vm.$t("apiId") },
                                        model: {
                                          value: _vm.clientInEdit.eeveeOrgId,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.clientInEdit,
                                              "eeveeOrgId",
                                              $$v
                                            )
                                          },
                                          expression: "clientInEdit.eeveeOrgId"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.clientInEdit.type === "organization"
                            ? _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { md3: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.$t("weChatGroupId")
                                        },
                                        model: {
                                          value: _vm.clientInEdit.weChatGroupId,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.clientInEdit,
                                              "weChatGroupId",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "clientInEdit.weChatGroupId"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.clientInEdit.type === "warehouse"
                            ? _c(
                                "v-layout",
                                { attrs: { "align-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { md3: "" } },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: _vm.$t("labelMapping")
                                        },
                                        model: {
                                          value: _vm.clientInEdit.labelMapping,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.clientInEdit,
                                              "labelMapping",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "clientInEdit.labelMapping"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.clientInEdit.labelMapping
                                    ? _c(
                                        "v-flex",
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: _vm.$t("scanLabelTotal"),
                                              readonly: ""
                                            },
                                            model: {
                                              value: _vm.scanLabelTotal,
                                              callback: function($$v) {
                                                _vm.scanLabelTotal = $$v
                                              },
                                              expression: "scanLabelTotal"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.clientInEdit.labelMapping
                                    ? _c(
                                        "v-flex",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { flat: "" },
                                              on: {
                                                click: function($event) {
                                                  _vm.isShowScanLabelStatisticsDetail = true
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(_vm.$t("detail")))]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.clientInEdit.type === "warehouse"
                            ? _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { md6: "" } },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: { "justify-space-between": "" }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md6: "" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "extraDepositFee"
                                                  ),
                                                  suffix: "%",
                                                  rules: [_vm.fieldIsNumber()]
                                                },
                                                model: {
                                                  value:
                                                    _vm.clientInEdit
                                                      .depositFeePercent,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.clientInEdit,
                                                      "depositFeePercent",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "clientInEdit.depositFeePercent"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { md4: "" } },
                                            [
                                              _c("v-checkbox", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "disableOutbound"
                                                  )
                                                },
                                                model: {
                                                  value:
                                                    _vm.clientInEdit
                                                      .isDisabledOutbound,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.clientInEdit,
                                                      "isDisabledOutbound",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "clientInEdit.isDisabledOutbound"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { md7: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: {
                                        "justify-space-between": "",
                                        "align-center": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { md5: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: _vm.$t("clientKey"),
                                              readonly: "",
                                              value: _vm.clientInEdit.clientKey
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "append",
                                                  fn: function() {
                                                    return [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: "primary"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.copyToClipboard(
                                                                _vm.clientInEdit
                                                                  .clientKey
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("content_copy")]
                                                      )
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              ],
                                              null,
                                              false,
                                              2356272811
                                            )
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { md5: "", "ml-3": "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: _vm.$t("clientName"),
                                              readonly: "",
                                              value: _vm.clientInEdit.clientName
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "append",
                                                  fn: function() {
                                                    return [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: "primary"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.copyToClipboard(
                                                                _vm.clientInEdit
                                                                  .clientName
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("content_copy")]
                                                      )
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              ],
                                              null,
                                              false,
                                              485954619
                                            )
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { md5: "", "ml-3": "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: _vm.$t("email"),
                                              readonly: "",
                                              value: _vm.clientInEdit.email
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "append",
                                                  fn: function() {
                                                    return [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: "primary"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.copyToClipboard(
                                                                _vm.clientInEdit
                                                                  .email
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("content_copy")]
                                                      )
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              ],
                                              null,
                                              false,
                                              3207076361
                                            )
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { md1: "", "ml-3": "" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { flat: "" },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.copyToClipboard(
                                                    _vm.clientInfoText
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(_vm.$t("copyAll")))]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      label: _vm.$t("features"),
                                      items: _vm.enableBetaFeatures,
                                      chips: "",
                                      multiple: "",
                                      "item-text": "displayName",
                                      "item-value": "key",
                                      "deletable-chips": "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.clientInEdit.features,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.clientInEdit,
                                          "features",
                                          $$v
                                        )
                                      },
                                      expression: "clientInEdit.features"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      label: _vm.$t("unVisibleFeature"),
                                      items: _vm.enableBetaFeatures,
                                      chips: "",
                                      multiple: "",
                                      "item-text": "displayName",
                                      "item-value": "key",
                                      "deletable-chips": "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.clientInEdit.inVisibleFeatures,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.clientInEdit,
                                          "inVisibleFeatures",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "clientInEdit.inVisibleFeatures"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          (_vm.clientInEdit.features || []).includes(
                            "FEDEX_LTL"
                          )
                            ? _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    [
                                      _c("v-autocomplete", {
                                        attrs: {
                                          label: _vm.$t("freightSites"),
                                          items: ["ALL"].concat(
                                            _vm.freightSites.map(function(
                                              site
                                            ) {
                                              return site.siteId
                                            })
                                          ),
                                          chips: "",
                                          multiple: "",
                                          "deletable-chips": "",
                                          clearable: ""
                                        },
                                        model: {
                                          value: _vm.clientInEdit.freightSites,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.clientInEdit,
                                              "freightSites",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "clientInEdit.freightSites"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c("v-textarea", {
                                staticClass: "thinBox",
                                attrs: {
                                  label: _vm.$t("note"),
                                  outline: "",
                                  rows: "5",
                                  counter: "10000"
                                },
                                model: {
                                  value: _vm.clientInEdit.note,
                                  callback: function($$v) {
                                    _vm.$set(_vm.clientInEdit, "note", $$v)
                                  },
                                  expression: "clientInEdit.note"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2569324097
            ),
            model: {
              value: _vm.configDialog,
              callback: function($$v) {
                _vm.configDialog = $$v
              },
              expression: "configDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.applicationDialog
        ? _c(
            "FormSubmitPopup",
            {
              attrs: {
                title: _vm.$t("application"),
                medium: "",
                hideRgtBtn: true
              },
              on: {
                popupClose: function($event) {
                  _vm.applicationDialog = false
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "input",
                    fn: function() {
                      return [
                        _c(
                          "v-tabs",
                          {
                            attrs: { color: "transparent", "show-arrows": "" },
                            model: {
                              value: _vm.tab,
                              callback: function($$v) {
                                _vm.tab = $$v
                              },
                              expression: "tab"
                            }
                          },
                          [
                            _c("v-tabs-slider", {
                              attrs: { color: "primary" }
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.applicationTabs, function(tabItem) {
                              return _c("v-tab", { key: tabItem }, [
                                _c("span", { staticClass: "tabItem" }, [
                                  _vm._v(
                                    "\n        " +
                                      _vm._s(_vm.$t(tabItem.toLowerCase())) +
                                      "\n      "
                                  )
                                ])
                              ])
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.applicationTabs.length, function(
                              item,
                              index
                            ) {
                              return _c(
                                "v-tab-item",
                                { key: "item" + index },
                                [
                                  index === 0
                                    ? _c("PaginationController", {
                                        ref: "applicationTableController",
                                        refInFor: true,
                                        attrs: {
                                          getDataActionName:
                                            "getApplicationList",
                                          actionPredicates:
                                            _vm.actionPredicates,
                                          historyLimit: 25,
                                          haveStartDate: false,
                                          haveNoEndDate: true,
                                          showSearchBoxLabel: false,
                                          outsideScrollToBottom: false,
                                          searchBoxLabel: _vm.$t(
                                            "searchForKeywords"
                                          ),
                                          refresh: _vm.refreshTable
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "dataTable",
                                              fn: function() {
                                                return [
                                                  _c("v-data-table", {
                                                    staticClass:
                                                      "elevation-2 myDense",
                                                    attrs: {
                                                      headers:
                                                        _vm.applicationHeaders,
                                                      items:
                                                        _vm.applicationList,
                                                      "item-key": "_key"
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "items",
                                                          fn: function(ref) {
                                                            var item = ref.item
                                                            return [
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.name
                                                                  )
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "text-xs-left"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.feature
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "text-xs-left"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.toTimestampString(
                                                                        item.createTime
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "text-xs-left"
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-btn",
                                                                    {
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.downloadFile(
                                                                            item
                                                                              .uploadFiles[0]
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item
                                                                            .uploadFiles[0]
                                                                            .name
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "text-xs-center"
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-flex",
                                                                    {
                                                                      attrs: {
                                                                        row: "",
                                                                        "align-center":
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-btn",
                                                                        {
                                                                          attrs: {
                                                                            color:
                                                                              "primary",
                                                                            flat:
                                                                              "",
                                                                            dark:
                                                                              "",
                                                                            icon:
                                                                              "",
                                                                            loading:
                                                                              item.loading
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.handleApplication(
                                                                                "success",
                                                                                item
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              attrs: {
                                                                                dark:
                                                                                  ""
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "check"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "v-btn",
                                                                        {
                                                                          attrs: {
                                                                            color:
                                                                              "red",
                                                                            flat:
                                                                              "",
                                                                            dark:
                                                                              "",
                                                                            icon:
                                                                              "",
                                                                            loading:
                                                                              item.loading
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.handleApplication(
                                                                                "reject",
                                                                                item
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              attrs: {
                                                                                dark:
                                                                                  ""
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "cancel"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "v-btn",
                                                                        {
                                                                          attrs: {
                                                                            color:
                                                                              "primary",
                                                                            flat:
                                                                              "",
                                                                            dark:
                                                                              "",
                                                                            icon:
                                                                              "",
                                                                            loading:
                                                                              item.loading
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.showCommentsDialog(
                                                                                item
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              attrs: {
                                                                                dark:
                                                                                  ""
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "comment"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: _vm.applicationList,
                                          callback: function($$v) {
                                            _vm.applicationList = $$v
                                          },
                                          expression: "applicationList"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  index === 1 && _vm.tab === 1
                                    ? _c("PaginationController", {
                                        ref:
                                          "historyApplicationTableController",
                                        refInFor: true,
                                        attrs: {
                                          getDataActionName:
                                            "getApplicationList",
                                          actionPredicates:
                                            _vm.historyActionPredicates,
                                          historyLimit: 25,
                                          outsideScrollToBottom: false,
                                          searchBoxLabel: _vm.$t(
                                            "searchForKeywords"
                                          ),
                                          haveStartDate: false,
                                          haveNoEndDate: true,
                                          refresh: _vm.refreshTable
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "dataTable",
                                              fn: function() {
                                                return [
                                                  _c("v-data-table", {
                                                    staticClass:
                                                      "elevation-2 myDense",
                                                    attrs: {
                                                      headers:
                                                        _vm.historyApplicationHeaders,
                                                      items:
                                                        _vm.historyApplicationList,
                                                      "item-key": "_key"
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "items",
                                                          fn: function(ref) {
                                                            var item = ref.item
                                                            return [
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.name
                                                                  )
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "text-xs-left"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.feature
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "text-xs-left"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.toTimestampString(
                                                                        item.createTime
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "text-xs-left"
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-btn",
                                                                    {
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.downloadFile(
                                                                            item
                                                                              .uploadFiles[0]
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item
                                                                            .uploadFiles[0]
                                                                            .name
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: _vm.historyApplicationList,
                                          callback: function($$v) {
                                            _vm.historyApplicationList = $$v
                                          },
                                          expression: "historyApplicationList"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            })
                          ],
                          2
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                946518578
              ),
              model: {
                value: _vm.applicationDialog,
                callback: function($$v) {
                  _vm.applicationDialog = $$v
                },
                expression: "applicationDialog"
              }
            },
            [_vm._v("\n  >\n\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.commentsDialog
        ? _c("ChatRoom", {
            attrs: {
              docPath: ["featureApplication", _vm.applicationInSupport._key],
              comments: _vm.comments,
              createConnection: true
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "issue",
                  fn: function() {
                    return [
                      _c(
                        "v-card",
                        { attrs: { hover: "", raised: "" } },
                        [
                          _c("v-card-text", [
                            _c(
                              "div",
                              {
                                staticClass: "cardTitle",
                                staticStyle: { "overflow-wrap": "break-word" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("createTime")) +
                                    ": " +
                                    _vm._s(
                                      _vm.toTimestampString(
                                        _vm.applicationInSupport.createTime
                                      )
                                    )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "cardTitle",
                                staticStyle: { "overflow-wrap": "break-word" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("tenant")) +
                                    ": " +
                                    _vm._s(_vm.applicationInSupport.name)
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "cardTitle",
                                staticStyle: { "overflow-wrap": "break-word" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("featureApplication")) +
                                    ": " +
                                    _vm._s(_vm.applicationInSupport.feature)
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "cardTitle",
                                staticStyle: { "overflow-wrap": "break-word" }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("files")) +
                                    ":\n          "
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.downloadFile(
                                          _vm.applicationInSupport
                                            .uploadFiles[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.applicationInSupport.uploadFiles[0]
                                          .name
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1635191994
            ),
            model: {
              value: _vm.commentsDialog,
              callback: function($$v) {
                _vm.commentsDialog = $$v
              },
              expression: "commentsDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.billingDetailDialog
        ? _c("BillingDetails", {
            attrs: {
              tenantKey: _vm.clientInView,
              client: _vm.clientItemInView,
              warehouseKey: "system"
            },
            model: {
              value: _vm.billingDetailDialog,
              callback: function($$v) {
                _vm.billingDetailDialog = $$v
              },
              expression: "billingDetailDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.labelInvoiceDetailDialog
        ? _c("LabelInvoiceDetails", {
            attrs: {
              tenantKey: _vm.selectedClientKey,
              selectedClientInfo: _vm.selectedClientInfo
            },
            model: {
              value: _vm.labelInvoiceDetailDialog,
              callback: function($$v) {
                _vm.labelInvoiceDetailDialog = $$v
              },
              expression: "labelInvoiceDetailDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.OfflineDepositDialog
        ? _c("OfflineDepositPopup", {
            model: {
              value: _vm.OfflineDepositDialog,
              callback: function($$v) {
                _vm.OfflineDepositDialog = $$v
              },
              expression: "OfflineDepositDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.dayEndClosingDialog
        ? _c("DayEndClosingPopup", {
            attrs: { clients: _vm.balances },
            model: {
              value: _vm.dayEndClosingDialog,
              callback: function($$v) {
                _vm.dayEndClosingDialog = $$v
              },
              expression: "dayEndClosingDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowEditTagsPopup
        ? _c("SimpleTextPopup", {
            attrs: { rightMethod: _vm.saveTags, title: _vm.$t("tag") },
            on: {
              popupClose: function() {
                return (this$1.isShowEditTagsPopup = false)
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c("v-combobox", {
                        attrs: {
                          items: _vm.activeTagsList,
                          "item-text": "displayName",
                          "item-value": "key",
                          label: _vm.$t("clientTag"),
                          "return-object": false,
                          chips: "",
                          multiple: "",
                          clearable: ""
                        },
                        model: {
                          value: _vm.currentItemTagKeys,
                          callback: function($$v) {
                            _vm.currentItemTagKeys = $$v
                          },
                          expression: "currentItemTagKeys"
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              4132440580
            ),
            model: {
              value: _vm.isShowEditTagsPopup,
              callback: function($$v) {
                _vm.isShowEditTagsPopup = $$v
              },
              expression: "isShowEditTagsPopup"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowScanLabelStatisticsDetail
        ? _c("SimpleTextPopup", {
            attrs: { title: _vm.$t("statistics"), hideRgtBtn: "", medium: "" },
            on: {
              popupClose: function() {
                return (this$1.isShowScanLabelStatisticsDetail = false)
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-layout",
                        { attrs: { row: "", "justify-space-between": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", md6: "" } },
                            [
                              _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    "nudge-right": 40,
                                    lazy: "",
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "full-width": "",
                                    "min-width": "290px"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(data) {
                                          return [
                                            _c(
                                              "v-text-field",
                                              _vm._g(
                                                {
                                                  attrs: {
                                                    label: _vm.$t("startDate"),
                                                    "prepend-icon": "event",
                                                    readonly: ""
                                                  },
                                                  model: {
                                                    value: _vm.startDateString,
                                                    callback: function($$v) {
                                                      _vm.startDateString = $$v
                                                    },
                                                    expression:
                                                      "startDateString"
                                                  }
                                                },
                                                data.on
                                              )
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3443685984
                                  ),
                                  model: {
                                    value: _vm.startMenu,
                                    callback: function($$v) {
                                      _vm.startMenu = $$v
                                    },
                                    expression: "startMenu"
                                  }
                                },
                                [
                                  _vm._v(" "),
                                  _c("v-date-picker", {
                                    attrs: {
                                      min:
                                        _vm.tab === 1
                                          ? _vm.selectedStat[0]
                                            ? _vm.selectedStat[0].dateKeyStr
                                            : ""
                                          : ""
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.startMenu = false
                                      }
                                    },
                                    model: {
                                      value: _vm.startDateString,
                                      callback: function($$v) {
                                        _vm.startDateString = $$v
                                      },
                                      expression: "startDateString"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "" } },
                            [
                              _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    "nudge-right": 40,
                                    lazy: "",
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "full-width": "",
                                    "min-width": "290px"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(data) {
                                          return [
                                            _c(
                                              "v-text-field",
                                              _vm._g(
                                                {
                                                  attrs: {
                                                    label: _vm.$t("endDate"),
                                                    "prepend-icon": "event",
                                                    readonly: ""
                                                  },
                                                  model: {
                                                    value: _vm.endDateString,
                                                    callback: function($$v) {
                                                      _vm.endDateString = $$v
                                                    },
                                                    expression: "endDateString"
                                                  }
                                                },
                                                data.on
                                              )
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    2953879808
                                  ),
                                  model: {
                                    value: _vm.endMenu,
                                    callback: function($$v) {
                                      _vm.endMenu = $$v
                                    },
                                    expression: "endMenu"
                                  }
                                },
                                [
                                  _vm._v(" "),
                                  _c("v-date-picker", {
                                    attrs: {
                                      min:
                                        _vm.tab === 1
                                          ? _vm.selectedStat[0]
                                            ? _vm.selectedStat[0].dateKeyStr
                                            : ""
                                          : ""
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.endMenu = false
                                      }
                                    },
                                    model: {
                                      value: _vm.endDateString,
                                      callback: function($$v) {
                                        _vm.endDateString = $$v
                                      },
                                      expression: "endDateString"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-data-table", {
                        attrs: {
                          headers: _vm.historyHeaders,
                          items: _vm.matchedDailyScanLabelStats
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "items",
                              fn: function(props) {
                                return [
                                  _c("td", { staticClass: "subheading" }, [
                                    _vm._v(_vm._s(props.index + 1))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-xs-left" }, [
                                    _vm._v(_vm._s(props.item.dateKeyStr))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-xs-left" }, [
                                    _vm._v(_vm._s(props.item.scanItems))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3355752562
                        )
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1700747919
            ),
            model: {
              value: _vm.isShowScanLabelStatisticsDetail,
              callback: function($$v) {
                _vm.isShowScanLabelStatisticsDetail = $$v
              },
              expression: "isShowScanLabelStatisticsDetail"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.exportClientsRechargeTransactionDialog
        ? _c("ExportClientsRechargeTransactionPopup", {
            attrs: { clients: _vm.balances },
            model: {
              value: _vm.exportClientsRechargeTransactionDialog,
              callback: function($$v) {
                _vm.exportClientsRechargeTransactionDialog = $$v
              },
              expression: "exportClientsRechargeTransactionDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isSystemSalesRoleOnly
        ? _c("ExportClientExpenseDetailsPopup", {
            attrs: { exportTableData: _vm.exportTableData },
            model: {
              value: _vm.exportClientsExpenseDetailsDialog,
              callback: function($$v) {
                _vm.exportClientsExpenseDetailsDialog = $$v
              },
              expression: "exportClientsExpenseDetailsDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59caefc4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59caefc4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BillingAdmin.vue
// module id = null
// module chunks = 